import {NgModule} from '@angular/core';
import {CfConfigPage} from "./page/overview/cf-config/cf-config.page";
import {CF_ENTITY_PROVIDER} from "./cf.entity-provider";
import {CoreModule} from "../../core/core.module";
import {CF_TEST_PROVIDERS} from "./test/cf-test-definition";
import {CfFrequencyObjectComponent} from "./component/object-components/cf-frequency-object-component/cf-frequency-object.component";
import {CfRoundingRuleObjectComponent} from "./component/object-components/cf-rounding-rule-object-component/cf-rounding-rule-object.component";


@NgModule({
    declarations: [
        CfConfigPage,
        CfFrequencyObjectComponent,
        CfRoundingRuleObjectComponent,

    ],
    exports: [
        CfConfigPage,
        CfFrequencyObjectComponent,
        CfRoundingRuleObjectComponent,

    ],
    imports: [
        CoreModule
    ], providers: [CF_ENTITY_PROVIDER, CF_TEST_PROVIDERS]
})
export class CfModule {
}
